let recaptchaSiteKey = "6Lc69uEqAAAAAIRoo-V0U3MB4YJTrdtdypDRLMPd";

if (process.env.REACT_APP_FIREBASE_PROD === "YES") {
  recaptchaSiteKey = "6Lc36OIqAAAAADdJ8DsVgy8Nm-lkds8yI_IAZroy";
}

export default recaptchaSiteKey;
